import * as React from 'react';

import InProgress16 from './InProgress16';

export const inProgress16 = () => <InProgress16 />;

export default {
    title: 'Icon/Fill/InProgress16',
    component: InProgress16,
    parameters: {
        notes: "`import InProgress16 from 'box-ui-elements/es/icon/fill/InProgress16';`",
    },
};
